"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/core/styles");
var withWidth_1 = __importDefault(require("@material-ui/core/withWidth"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        button: {
            marginLeft: theme.spacing(2),
        },
        checkbox: {
            paddingTop: theme.spacing(4),
            fontSize: '12px',
        },
        image: {
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: theme.spacing(2),
        },
        title: {
            fontSize: '24px',
            marginTop: theme.spacing(2),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            textAlign: 'center',
        },
        description: {
            fontSize: '18px',
            textAlign: 'center',
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    });
});
var _ConfirmDialog = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(false), checked = _a[0], setChecked = _a[1];
    var _b = react_1.default.useState(), showMessengerOnClose = _b[0], setShowMessengerOnClose = _b[1];
    react_1.default.useEffect(function () {
        if (props.open) {
            if (window.intercomMessenger) {
                window.Intercom('update', {
                    hide_default_launcher: true,
                });
                window.intercomMessenger = false;
                setShowMessengerOnClose(true);
            }
        }
    }, [props.open]);
    var handleClose = function () {
        if (showMessengerOnClose) {
            window.Intercom('update', {
                hide_default_launcher: false,
            });
            window.intercomMessenger = false;
        }
    };
    var onOK = function () {
        handleClose();
        if (props.secondaryCheck) {
            props.onOK(checked);
        }
        else {
            props.onOK();
        }
    };
    var onCancel = function () {
        handleClose();
        props.onClose();
    };
    var dialogContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.title }, props.title),
        react_1.default.createElement(DialogContent_1.default, null,
            !!props.image && (react_1.default.createElement("img", { className: classes.image, width: "64px", height: "64px", src: props.image })),
            react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.description, id: "alert-dialog-description" }, props.description),
            props.secondaryCheck ? (react_1.default.createElement(FormControlLabel_1.default, { className: classes.checkbox, control: react_1.default.createElement(Checkbox_1.default, { checked: checked, onChange: function (e) { return setChecked(e.target.checked); }, key: "check", color: "primary" }), label: props.secondaryCheck })) : null),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            !props.onlyShowYesButton && (react_1.default.createElement(Button_1.default, { onClick: onCancel, variant: "contained", fullWidth: true, className: classes.button, color: "secondary" }, props.noText || strings_1.default.no)),
            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", fullWidth: true, className: classes.button + " " + (props.yesIsDestructive ? 'button-coral' : ''), onClick: onOK }, props.yesText || strings_1.default.yes))));
    return (react_1.default.createElement(Dialog_1.default, { fullScreen: props.width === 'xs' || props.width === 'sm', open: props.open, onClose: onCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, dialogContent));
};
exports.ConfirmDialog = withWidth_1.default({ initialWidth: 'lg' })(_ConfirmDialog);
